window.KROWN = window.KROWN || {};

KROWN.themeName = 'Kingdom';
KROWN.themeVersion = '5.2.1';

const executeOnceOnDomContentLoaded = () => {
  // Input helper
  document.querySelectorAll('input').forEach(elm => {
    elm.addEventListener('change', e => {
      e.target.classList.toggle('filled', e.target.value !== '');
    });
  });

  document.querySelectorAll('input[type="search"]').forEach(elm => elm.value = '');

  // Tab accessibility
  let activeElement = document.activeElement;
  document.addEventListener('keyup', e => {
    if (e.key === 'Tab') {
      if (activeElement?.classList?.contains('focus') && e.target !== activeElement) {
        activeElement.classList.remove('focus');
      }
      if (
        e.target.classList.contains('regular-select-cover') ||
        e.target.classList.contains('search-field') ||
        e.target.classList.contains('product-item__link') ||
        e.target.classList.contains('content-slider') ||
        e.target.classList.contains('blog-item__header') ||
        e.target.classList.contains('toggle__title') ||
        e.target.tagName === 'INPUT'
      ) {
        activeElement = e.target;
        e.target.classList.add('focus');
      }
    }
  });

// Dropdown submenu toggle
const submenuToggles = document.querySelectorAll('.sidebar__menu .has-submenu > a');
submenuToggles.forEach(toggle => {
  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    const submenu = this.parentElement.querySelector('.sidebar__submenu');
    if (submenu) {
      const isExpanded = submenu.getAttribute('aria-expanded') === 'true';
      submenu.setAttribute('aria-expanded', (!isExpanded).toString());
      submenu.classList.toggle('active');
      submenu.style.display = isExpanded ? 'none' : 'block';
    }
  });
});

  // Hover behavior for sidebar submenu
document.querySelectorAll('.sidebar__menu .has-submenu').forEach(item => {
  const submenu = item.querySelector('.sidebar__submenu');

  item.addEventListener('mouseenter', () => {
    if (submenu) {
      submenu.classList.add('active');
      submenu.setAttribute('aria-expanded', 'true');
      submenu.style.display = 'block';
    }
  });

  item.addEventListener('mouseleave', () => {
    if (submenu) {
      submenu.classList.remove('active');
      submenu.setAttribute('aria-expanded', 'false');
      submenu.style.display = 'none';
    }
  });
});

  // Newsletter scroll
  if (window.location.search === '?customer_posted=true') {
    setTimeout(() => {
      const alert = document.querySelector('form .alert');
      if (alert) {
        window.scroll({ top: alert.offsetTop - 250, behavior: 'smooth' });
      }
    }, 300);
  } else if (window.location.pathname.includes('/challenge')) {
    setTimeout(() => {
      window.scroll({ top: 0, behavior: 'auto' });
    }, 300);
  }
};

// Run script
if (document.readyState !== 'loading') {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// Define cart refresh only once
if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=cart-helper')
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        if (cartItems) {
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();
          document.querySelector('[data-header-cart-count]').textContent = cartItems.querySelector('[data-cart-count]').textContent;
        }

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

        const cartSidebar = document.querySelector('.sidebar__cart');
        if (cartSidebar && cartSidebar.show) {
          cartSidebar.show();
        }
      });
  };
}
document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.querySelector('.sidebar__toggle');
  const sidebar = document.querySelector('main-sidebar');

  if (menuToggle && sidebar) {
    menuToggle.addEventListener('click', function () {
      sidebar.classList.toggle('active');
      menuToggle.classList.toggle('is-active');
    });
  }
});
